// Official KINDSTONE logo assets from Brand Standards Master V2.
// Single source of truth for website logo paths. Never modify the artwork.
export const LOGOS = {
  // Full circular character mark — reserved for larger branded placements.
  masterLogo: '/brand/ks-master-logo-web.png',

  // KS-04 Horizontal — desktop header and footer.
  horizontal: '/brand/ks-04-horizontal.webp',

  // KS-03 Primary Simplified — compact/mobile brand placement.
  primarySimplified: '/brand/ks-03-primary-simplified.png',

  // KS-05 Symbol/Icon — favicon and small digital placements.
  symbol: '/brand/ks-05-symbol.png',
  favicon: '/brand/ks-05-favicon-48.png',
  appleTouch: '/brand/ks-05-apple-touch-icon.png',
};
